export interface WinePackageWidgetModel {
  title: string;
  id: number;
  productVariantId: number;
  showWineBottlesInFront: boolean; // ha true, csak a foregroundImage-t kell megjeleníteni
  backgroundImage: string;
  foregroundImage: string;
  availableQuantity: number;
  description: string;
  basePrice: number | null;
  discount: number;
  currentPrice: number | null;
  content: PackageElement[];
  currentEurPrice: number | null;
  baseEurPrice: number | null;

  showEurPrice: boolean;
  minimumCartQuantity: number;
  maximumCartQuantity: number;
}

export interface PackageElement {
  id: number;
  title: string;
  productYear: number;
}

export const getFeaturedPackages = async () => {
  try {
    const response = await fetch(`/Widget/FeaturedPackages`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return (await response.json()) as WinePackageWidgetModel[];
  } catch (error) {
    throw new Error(error);
  }
};
